'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramdaAdjunct = require('ramda-adjunct');

var _ramda = require('ramda');

var _transformer = require('../transformer');

var _transformer2 = _interopRequireDefault(_transformer);

var _baseline = require('../../utils/baseline');

var _transformers = require('../../utils/transformers');

var _keysToObjectValuesResolver = require('../../resolvers/keysToObjectValuesResolver');

var _keysToObjectValuesResolver2 = _interopRequireDefault(_keysToObjectValuesResolver);

var _converters = require('../../utils/converters');

var _keyToValueResolver = require('../../resolvers/keyToValueResolver');

var _keyToValueResolver2 = _interopRequireDefault(_keyToValueResolver);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rhythmUnitsToRemsTransformer = function rhythmUnitsToRemsTransformer(fontSizeToLengthTransformer) {
  return (0, _transformer2.default)(_ramda.T, function (value, data, breakpointName) {
    var _keysToObjectValuesRe = (0, _keysToObjectValuesResolver2.default)('baseline', ['lineHeight', 'minLeading', 'allowHalfLines'])(data, breakpointName),
        _keysToObjectValuesRe2 = _slicedToArray(_keysToObjectValuesRe, 3),
        lineHeight = _keysToObjectValuesRe2[0],
        minLeading = _keysToObjectValuesRe2[1],
        allowHalfLines = _keysToObjectValuesRe2[2];

    var baseFontSize = (0, _keyToValueResolver2.default)('baseFontSize')(value, data, breakpointName);

    var _unless = (0, _ramda.unless)(_ramdaAdjunct.isArray, _formatting.splitOnUnnestedWhitespace)(value),
        _unless2 = _slicedToArray(_unless, 2),
        fontSize = _unless2[0],
        lines = _unless2[1];

    var transformedFontSize = (0, _transformers.transformValue)(fontSizeToLengthTransformer, fontSize, data, breakpointName);
    var fontSizeUnitlessPx = (0, _converters.unitedDimensionToUnitlessPixelValue)(transformedFontSize, baseFontSize);

    var transformedLines = (0, _ramda.pipe)((0, _ramda.when)(_ramdaAdjunct.isUndefined, function () {
      return (0, _baseline.linesForFontsize)(minLeading, allowHalfLines, lineHeight, fontSizeUnitlessPx);
    }), (0, _ramda.multiply)(lineHeight), (0, _transformers.transformValue)(fontSizeToLengthTransformer, _ramda.__, data, breakpointName))(lines);

    return [transformedFontSize, transformedLines];
  });
};

exports.default = rhythmUnitsToRemsTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/composite/baselineTransformer.js
// module id = 665
// module chunks = 168707334958949